import { render, staticRenderFns } from "./receive_edit.vue?vue&type=template&id=432be115&scoped=true"
import script from "./receive_edit.vue?vue&type=script&lang=js"
export * from "./receive_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432be115",
  null
  
)

export default component.exports